import Tasks from 'APP/Tasks';
import { ApiError } from 'APP/restApi/error/ApiError';
import { bffRestClient } from 'APP/restApi/restClient/restClient';
import Entities from 'STORE';

let loginPromise = Promise.resolve();

export async function sessionExpiredHandler<D>(
  error: ApiError,
  prevAccessToken: string | null,
  resolve: (request: Promise<D>) => void,
  reject: (error: Error) => void
): Promise<void> {
  await loginPromise;
  const accessToken = Entities.authStore.connectionToken;

  // if there were no active logins, and we are not logged in, we initiate a session update
  if (prevAccessToken === accessToken && accessToken !== null) {
    loginPromise = new Promise(async (resolveLogin) => {
      const isSuccess = await Tasks.authorization.refreshToken();
      if (!isSuccess) {
        Tasks.authorization.logout();
      }
      resolveLogin();
    });
  }

  await loginPromise;

  if (accessToken === null) {
    return reject(error);
  }

  resolve(bffRestClient.request(error.requestEndpoint, error.requestOptions));
}
